import { ReducerAction } from '../ReducerAction';
import { ModalSaleSetup, ModalStep, SaleLoaderState, SaleState, ClientBalanceInfo } from '../states/SaleState';
import { ActionType } from '../ActionsTypes';
import { RequestParam } from '../../../domain/models/RequestParam';

export const saleReducer = (state = new SaleState({
    modalShow: false,
    step: 0,
    setup: new ModalSaleSetup(),
    loader: new SaleLoaderState(),
    sku: undefined,
    elementsInBody: [],
    params: [],
    modalStep: ModalStep.SELECT_SKU,
    pdfFailed: false,
    // [Balance Step 3]: Valor inicial en el estado
    clientBalance: new ClientBalanceInfo(),
    loadingBalance: true,
}), action: ReducerAction) => {

    switch (action.type) {
        case ActionType.SALE_SET_MODAL_STEP:
            return new SaleState({
                ...state,
                modalStep: action.payload
            });
        case ActionType.SALE_RESET:
            return new SaleState({
                ...state,
                step: 0,
                setup: new ModalSaleSetup(),
                loader: new SaleLoaderState(),
                sku: undefined,
                params: [],
                elementsInBody: [],
                result: undefined,
                pdfFailed: false
            })
        case ActionType.SALE_NEXT:
            return new SaleState({
                ...state,
                step: state.step + 1
            });

        case ActionType.SALE_PREVIOUS:
            return new SaleState({
                ...state,
                step: state.step - 1
            });

        case ActionType.SALE_OPEN:
            const initialModalStep = action.payload.sku ? ModalStep.SKU_SALE : ModalStep.SELECT_SKU;
            return new SaleState({
                ...state,
                step: 0,
                modalShow: true,
                skuDetail: undefined,
                setup: action.payload,
                modalStep: initialModalStep
            })

        case ActionType.SALE_CLOSE:
            return new SaleState({
                ...state,
                step: 0,
                modalStep: ModalStep.SKU_SALE,
                modalShow: false,
                setup: new ModalSaleSetup()
            });

        case ActionType.SALE_SHOW_LOADING:
            return new SaleState({
                ...state,
                loader: new SaleLoaderState({
                    isLoading: true,
                    message: action.payload ?? "Procesando..."
                })
            });

        case ActionType.SALE_HIDE_LOADING:
            return new SaleState({
                ...state,
                loader: new SaleLoaderState({
                    isLoading: false,
                    message: ""
                })
            })

        case ActionType.SALE_SET_SKU:
            return new SaleState({
                ...state,
                sku: action.payload,
                modalStep: ModalStep.SKU_SALE

            })

        case ActionType.SALE_SET_SKU_DETAIL:
            return new SaleState({
                ...state,
                skuDetail: action.payload
            })

        case ActionType.SALE_ADD_PARAMS:
            let params = state.params;
            action.payload?.forEach((param: RequestParam) => {
                let index = params.findIndex((p: RequestParam) => {
                    return p.name === param.name
                });
                if (index >= 0) {
                    params[index] = param;
                } else {
                    params.push(param);
                }
            });

            return new SaleState({
                ...state,
                params: params
            });

        case ActionType.SALE_SET_PARAMS:
            return new SaleState({
                ...state,
                params: action.payload
            });

        case ActionType.SALE_SHOW_CONFIRM:
            return new SaleState({
                ...state,
                modalStep: ModalStep.CONFIRM,
            });

        case ActionType.SALE_SET_ELEMENTS_IN_BODY:
            return new SaleState({
                ...state,
                elementsInBody: action.payload
            });

        case ActionType.SALE_SET_RESULT:
            return new SaleState({
                ...state,
                modalStep: ModalStep.SKU_RESULT,
                result: action.payload
            });

        case ActionType.SALE_RETURN_TO_OPTIONS:
            return new SaleState({
                ...state,
                modalStep: ModalStep.SELECT_SKU,
                sku: undefined,
                skuDetail: undefined,
                result: undefined
            });

        case ActionType.SALE_SHOW_TICKET_FAILED:
            return new SaleState({
                ...state,
                pdfFailed: true
            });

        case ActionType.SALE_HIDE_TICKET_FAILED:
            return new SaleState({
                ...state,
                pdfFailed: false
            });

        // [Balance Step 5]: Manejador de acción para guardar mensaje
        case ActionType.SALE_SET_CLIENT_BALANCE:
            return {
                ...state,
                clientBalance: action.payload,
                loadingBalance: false
            };

        case ActionType.SALE_LOADING_BALANCE:
            return {
                ...state,
                loadingBalance: true
            }

        case ActionType.SALE_LOADING_INACTIVE_BALANCE:
            return {
                ...state,
                loadingBalance: false
            }

        default: return state;
    }
}